<template>
  <div id="main-listado-contrato-fechas">
    <template v-if="!$vuetify.breakpoint.mobile">
      <desktop desktop :listado="listado" />
    </template>
    <template v-else>
      <desktop desktop :listado="listado" />
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';

export default {
  name: 'MainListadoContratoFechas',
  components: {
    Desktop,
  },
  props: {
    listado: Array,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
